import { render, staticRenderFns } from "./BitsStoreReport.vue?vue&type=template&id=04798d40&scoped=true&"
import script from "./BitsStoreReport.vue?vue&type=script&lang=js&"
export * from "./BitsStoreReport.vue?vue&type=script&lang=js&"
import style0 from "./BitsStoreReport.vue?vue&type=style&index=0&id=04798d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04798d40",
  null
  
)

component.options.__file = "BitsStoreReport.vue"
export default component.exports